import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/** @jsx jsx */
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match
import { jsx } from '@emotion/core';
import { N200, N900 } from '@atlaskit/theme/colors';

var getStyles = function getStyles(isSecondary, shouldTruncate) {
  return _objectSpread(_objectSpread({
    display: 'block',
    margin: 0,
    color: "var(--ds-text, ".concat(N900, ")")
  }, shouldTruncate && {
    overflowX: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }), isSecondary && {
    color: "var(--ds-text-subtlest, ".concat(N200, ")"),
    fontSize: '0.85em'
  });
};
/**
 * __Text__
 *
 * Text is used internally only.
 */


var Text = function Text(_ref) {
  var isSecondary = _ref.isSecondary,
      children = _ref.children,
      shouldTruncate = _ref.shouldTruncate;
  return (// TODO: Refactor styles to follow css prop rules
    // eslint-disable-next-line @repo/internal/react/consistent-css-prop-usage
    jsx("span", {
      css: getStyles(isSecondary, shouldTruncate)
    }, children)
  );
};

export default Text;